import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors } from "@angular/forms";

/**
 * Generated class for the HorizontalRadioInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "horizontal-radio-input",
  templateUrl: "horizontal-radio-input.html",
})
export class HorizontalRadioInputComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() config: any;

  // Internal data model
  id: string;
  componentId: string;
  label: any;
  options: string[] = [];
  descriptions: object = {};
  selected: string;
  required: boolean;
  disabled: boolean;
  readonly: boolean = false;
  l;
  constructor(public formBuilder: FormBuilder) {}

  ngOnInit(): void {
    // console.log("Checkbox input config: ", this.config);

    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;
    this.descriptions = this.config.descriptions || {};
    if (this.config.rules) {
      this.required = this.config.rules.required;
    }

    if (!this.config.options) {
      console.error("Cannot build checkbox input, no options found.");
    }

    this.group.addControl(this.id, this.formBuilder.control({}));

    this.options = this.config.options;

    this.group.controls[this.id].valueChanges.subscribe((data) => {
      // console.log( "New radio value from parent group:", data );
      if (data !== undefined && data !== this.selected) {
        this.selected = data;
      }

      let outerDisabled = this.group.controls[this.id].disabled;
      if (outerDisabled !== this.disabled) {
        this.disabled = outerDisabled;
      }
      this.disabled = this.group.controls[this.id].disabled;
    });

    this.group.controls[this.id].setValue(this.group.controls[this.id].value);
    this.group.controls[this.id].setErrors(this.getErrors());
  }

  getDescription(option: string) {
    let desc = this.descriptions[option];

    return desc ? desc : "";
  }

  optionClicked(option: string) {
    // console.log( "Option clicked: ", option );
    if (this.disabled || this.readonly) {
      return;
    }

    this.selected = option;

    this.group.controls[this.id].setValue(this.selected);
    this.group.markAsDirty();

    this.group.controls[this.id].setErrors(this.getErrors());
  }

  getErrors(): ValidationErrors {
    let errors = {};
    if (this.required && !this.selected) {
      errors["required"] = true;
    }
    // console.log( "Determined radio errors:", errors );
    return Object.keys(errors).length == 0 ? undefined : errors;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/horizontal-radio-input/horizontal-radio-input.ts